export default __webpack_public_path__ + "static/media/vivo-sponsor.89e45772.svg";